<div class="pip-playground-container">
  <h1 class="axis-h2">PIP Playground</h1>
  <p class="_mb-large">This page shows the PIP workflow step by step on the same page.</p>

  <!-- Playground Controls  -->
  <axis-card class="_mb-large">
    <axis-card-heading class="stack-xs grid">
      <axis-card-heading-body>
        <h3 class="axis-h4">Playground Controls</h3>
      </axis-card-heading-body>
      <button
        axis-button
        class="kind-secondary"
        (click)="resetPlayground()"
      >
        <span class="axis-btn-icon-text">Reset Workflow</span>
      </button>
    </axis-card-heading>
    <axis-card-body>
      <form [formGroup]="playgroundForm">
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            for="statesDropdown"
            >Select States</label
          >
          <axis-dropdown
            class="has-axis-custom filter"
            [dataProvider]="stateList"
            [enableMultiSelectFilter]="true"
            id="statesDropdown"
            [isSelectAll]="true"
            templateClasses="axis-dropdown-filter"
            type="multiSelect"
            formControlName="selectedState"
            (selectionChange)="onStateChange($event)"
          ></axis-dropdown>
        </div>
      </form>
    </axis-card-body>
  </axis-card>

  <!-- Step 1: Selection Coverages - Always visible -->
  <axis-card
    class="_mb-large"
    #selectionCard
  >
    <axis-card-heading class="stack-xs">
      <axis-card-heading-body>
        <h2 class="axis-h3">1. Coverage Selection</h2>
      </axis-card-heading-body>
    </axis-card-heading>
    <axis-card-body>
      <app-pip-selection-coverages
        #selectionComponent
        (continueClickedPlayground)="onSelectionContinue()"
        (dataChangedPlayground)="onSelectionDataChanged()"
      >
      </app-pip-selection-coverages>
    </axis-card-body>
  </axis-card>

  <!-- Step 2: State Summary - Show after step 1 -->
  @if (summaryVisible) {
    <axis-card
      class="_mb-large"
      #summaryCard
    >
      <axis-card-heading class="stack-xs">
        <axis-card-heading-body>
          <h2 class="axis-h3">2. State Summary</h2>
        </axis-card-heading-body>
      </axis-card-heading>
      <axis-card-body>
        <app-pip-state-summary
          #summaryComponent
          (continueClickedPlayground)="onSummaryContinue()"
          (backClickedPlayground)="hideSummary()"
        >
        </app-pip-state-summary>
      </axis-card-body>
    </axis-card>
  }

  <!-- Step 3: Outstanding State Summary - Show after step 2 -->
  @if (outstandingVisible) {
    <axis-card
      class="_mb-large"
      #outstandingCard
    >
      <axis-card-heading class="stack-xs">
        <axis-card-heading-body>
          <h2 class="axis-h3">3. Outstanding State Summary</h2>
        </axis-card-heading-body>
      </axis-card-heading>
      <axis-card-body>
        <app-pip-outstanding-state-summary
          #outstandingComponent
          (continueClickedPlayground)="onOutstandingContinue()"
          (backClickedPlayground)="hideOutstanding()"
        >
        </app-pip-outstanding-state-summary>
      </axis-card-body>
    </axis-card>
  }

  <!-- Step 4: Signature - Show after step 3 -->
  @if (signatureVisible) {
    <axis-card
      class="_mb-large"
      #signatureCard
    >
      <axis-card-heading class="stack-xs">
        <axis-card-heading-body>
          <h2 class="axis-h3">4. Electronic Signature</h2>
        </axis-card-heading-body>
      </axis-card-heading>
      <axis-card-body>
        <app-pip-signature
          #signatureComponent
          (continueClickedPlayground)="onSignatureContinue()"
          (backClickedPlayground)="hideSignature()"
        >
        </app-pip-signature>
      </axis-card-body>
    </axis-card>
  }

  <!-- Step 5: Thank You - Show after step 4 -->
  @if (thankYouVisible) {
    <axis-card
      class="_mb-large"
      #thankYouCard
    >
      <axis-card-heading class="stack-xs">
        <axis-card-heading-body>
          <h2 class="axis-h3">5. Thank You & Download</h2>
        </axis-card-heading-body>
      </axis-card-heading>
      <axis-card-body>
        <app-thank-you
          #thankYouComponent
          (workflowCompletePlayground)="onThankYouComplete()"
        >
        </app-thank-you>
      </axis-card-body>
    </axis-card>
  }
</div>
